import { useState } from "react";
import ChevronDownIcon from "../../../../../assets/icons/ChevronDownIcon";
import ChevronRightIcon from "../../../../../assets/icons/ChevronRightIcon";
import "./ThinkingBlocks.scss";
import Spinner from "../../../../../assets/icons/Spinner";

const ThinkingBlocks = ({ blocks }) => {
  const [expandedBlocks, setExpandedBlocks] = useState({});

  const toggleBlock = (blockIndex) => {
    setExpandedBlocks((prev) => ({
      ...prev,
      [blockIndex]: !prev[blockIndex],
    }));
  };

  const formatDuration = (durationMs) => {
    if (!durationMs) return "";
    const seconds = (durationMs / 1000).toFixed(1);
    return `${seconds}s`;
  };

  return (
    <div className="thinking_blocks">
      {blocks.map((block) => {
        const isExpanded = expandedBlocks[block.blockIndex] || false;
        const isStreaming = !block.isComplete;
        const duration = block.durationMs
          ? formatDuration(block.durationMs)
          : "...";

        return (
          <div key={block.blockIndex} className="thinking_block">
            <div
              className={`thinking_block_header ${
                block.isComplete ? "clickable" : ""
              }`}
              onClick={() => block.isComplete && toggleBlock(block.blockIndex)}
            >
              <div className="thinking_block_icon">
                {block.isComplete &&
                  (isExpanded ? (
                    <ChevronDownIcon size={20} color="#67748e" />
                  ) : (
                    <ChevronRightIcon size={20} color="#67748e" />
                  ))}
                {!block.isComplete && <Spinner size={20} color="#67748e" />}
              </div>
              <div className="thinking_block_title">
                {block.isComplete
                  ? `Thought for ${duration}`
                  : `Thinking ${duration}`}
              </div>
            </div>
            {(isExpanded || isStreaming) && (
              <div className="thinking_block_content">{block.content}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ThinkingBlocks;
